export default "__VITE_ASSET__fa20d2d7__"